import { USER_APIS } from "@/api_framework/api_config";
import { setDiagnosticIdentity } from "@/api_framework/tokenDiagnostics";
import { IUserRoleClinicList, IUserRoleResponse } from "@/api_framework/api_modals/UserRoles";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import {
  setAuthorization,
  setOAuthUser,
  setUserLoginInfo,
  setUserPermissions,
  setUserRole,
  setVMSuserId,
} from "@/app_redux/reducers/auth_reducer";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setOrderClinicList, setUserPermision } from "@/app_redux/reducers/slices/auth/order_management_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useFirebaseLogin } from "../auth/useFirebaseLogin";
import { useRouter } from "../../useRouter";

AxiosCurlirize(axios, () => {});
export const useUserRoleAPI = () => {
  const { clientSignOut } = useFirebaseLogin();
  const { getRouteKey } = useRouter();
  const {
    env: { version: appVersion },
    ...configuration
  } = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (withAuth: boolean = false) => {
      const finishLoading = () => {
        dispatch(
          setLoading({
            key: "isUserRoleInProgress",
            status: false,
          }),
        );
      };
      // const handleUnauthorized = () => {
      //   dispatch(
      //     setVMSuserId({
      //       data: null,
      //     }),
      //   );
      //   clientSignOut();
      //   window.open(getRouteKey("LOGIN_PAGE", "url"), "_self");
      // };

      dispatch(
        setLoading({
          key: "isUserRoleInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(USER_APIS?.USER_ROLE?.baseURL ?? "", {
            params: {},
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IUserRoleResponse>) => {
            if (res.data.status === true) {
              const sanitizedUserLoginInfo = { ...res.data.data };
              delete sanitizedUserLoginInfo.number;
              // Keep an in-memory copy so diagnostics stay attributable even
              // if localStorage is cleared out from under the session.
              setDiagnosticIdentity({
                vms_user_id: res.data.data?.email,
                clinic_id: localStorage.getItem(configuration.localStorage.CLINIC.key) ?? undefined,
                clinic_name: localStorage.getItem(configuration.localStorage.CLINIC_NAME.key) ?? undefined,
              });
              console.log(res.data.data?.user_id, "res.data.data");
              dispatch(setUserPermissions(res.data.data?.staff_role_details));

              dispatch(
                setUserLoginInfo({
                  data: sanitizedUserLoginInfo,
                }),
              );
              dispatch(
                setVMSuserId({
                  data: res.data?.data?.user_id,
                }),
              );
              dispatch(
                setUserRole({
                  data: res.data.data?.staff_role_details,
                }),
              );

              localStorage.setItem(configuration.localStorage.APP_VERSION.key, appVersion);

              dispatch(
                setOAuthUser({
                  displayName: res.data.data?.name,
                  email: res.data.data?.email,
                  photoURL: "",
                  mobile: res.data.data?.mobile ?? null,
                }),
              );

              localStorage.setItem(
                configuration.localStorage.USER_DETAILS.key,
                JSON.stringify({
                  displayName: res.data.data?.name,
                  email: res.data.data?.email,
                  photoURL: "",
                }),
              );

              dispatch(
                setAuthorization({
                  accessToken: `Bearer ${accessToken}`,
                  isValid: true,
                }),
              );

              // clinic and user permision on order
              const clinicsArray = [];
              res.data.data?.assigned_cities_clinics?.forEach((city: IUserRoleClinicList) => {
                city.clinics.forEach((clinic) => {
                  clinicsArray.push({ id: clinic.id, name: clinic.display_name });
                });
              });
              dispatch(setOrderClinicList({ data: clinicsArray }));
              // const permision = res.data.data?.staff_role_details as any;
              // console.log(permision, "permision");
              // dispatch(setUserPermision({ data: permision?.user_permissions }));

              dispatch(
                setLoading({
                  key: "isUserRoleInProgress",
                  status: false,
                }),
              );
            } else {
              // dispatch(setUserPermissions(null));
              dispatch(
                setUserRole({
                  data: null,
                }),
              );
              dispatch(
                setUserLoginInfo({
                  data: null,
                }),
              );
              dispatch(setOrderClinicList({ data: [] }));
              dispatch(setUserPermision({ data: [] }));
              finishLoading();
              // handleUnauthorized();
            }
          })
          .catch((e: AxiosError) => {
            const httpStatus = e?.response?.status;
            if (httpStatus === 401 || httpStatus === 403) {
              finishLoading();
              // handleUnauthorized();
              return;
            }
            // dispatch(setUserPermissions(null));
            if (e.config?.["curlCommand"]) {
              sendCurl(e.config["curlCommand"]);
            }
            captureError(e);
            if (!withAuth) {
              toast.error("Unable to refresh user session. Please check your network and retry.");
            }
            finishLoading();
          });
      } catch (e: any) {
        finishLoading();
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch, clientSignOut, getRouteKey, captureError, sendCurl],
  );
  return execute;
};
